interface BandwidthShieldProps {
  className?: string;
  color?: string;
}

export default function BandwidthShield({ className = '', color = '#10B981' }: BandwidthShieldProps) {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20 3L7 8.5V18.5C7 27.25 13.05 35.35 20 37C26.95 35.35 33 27.25 33 18.5V8.5L20 3Z'
        fill={color}
        fillOpacity='0.15'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 21C12 16.582 15.582 13 20 13C24.418 13 28 16.582 28 21'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path d='M14.5 20.5C14.5 17.739 16.739 15.5 19.5 15.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
      <circle cx='20' cy='21' r='1.5' fill={color} />
      <path d='M20 21L24.5 16.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
